// Maps a unified QuickBooks transaction (returned by /api/qb-transactions)
// into the shape used by the Transactions tab (one_off_payments). Handles
// money OUT (charges, bill payments, transfers) and money IN (deposits,
// refunds) by setting the `direction` field.

export function mapQbToTransaction(qb) {
  return {
    name: qb.name,
    category: null,
    date: qb.date,
    amount: Number(qb.amount) || 0,
    notes: qb.memo || qb.docNumber || null,
    offerId: null,
    costType: "opex",
    department: null,
    status: "flagged",
    externalId: qb.externalId,
    externalStatus: "Completed",
    currency: qb.currency || "USD",
    direction: qb.direction || "out",
    qbType: qb.qbType || null,
  };
}

// Returns only QB rows whose externalId isn't already in the local txn list,
// so re-syncing is idempotent.
export function dedupeNew(qbTxns, existingTxns) {
  const seen = new Set(
    (existingTxns || []).map((t) => t.externalId).filter(Boolean)
  );
  return qbTxns.filter((t) => t.externalId && !seen.has(t.externalId));
}